export default __webpack_public_path__ + "static/24-45687c5b1561808dc1fa2b082d6eb881.jpg";